import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { KIKI } from "@/constants/testIds";
import { useT, useLang } from "@/lib/i18n";

export function FAQ() {
  const t = useT();
  const { lang } = useLang();
  const isHi = lang === "hi";
  const items = t("faq.items");

  return (
    <section id="faq" data-testid={KIKI.faq} className="relative py-16 md:py-24">
      <div className="max-w-[90rem] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 md:gap-10">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-baseline gap-4 mb-6">
              <span className="font-mono text-sm text-muted-foreground">06</span>
              <span className={`label-overline text-muted-foreground ${isHi ? "font-hindi tracking-normal text-[12px]" : ""}`}>{t("faq.overline")}</span>
            </div>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              className={`font-black text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight ${isHi ? "font-hindi" : "font-sans"}`}
            >
              {t("faq.titleA")}<br />
              <span className={isHi ? "font-hindi" : "font-display italic font-normal"}>{t("faq.titleB")}</span>
            </motion.h2>
            <p className={`mt-6 text-muted-foreground max-w-sm text-sm md:text-base leading-relaxed ${isHi ? "font-hindi" : ""}`}>
              {t("faq.callNote1")}<a href="tel:+918800288994" className="text-foreground font-semibold link-sweep">+91 88002 88994</a>{t("faq.callNote2")}
            </p>
          </div>
          <div className="col-span-12 md:col-span-7">
            <Accordion type="single" collapsible className="w-full">
              {items.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} data-testid={`${KIKI.faqItem}-${i}`} className="border-b border-border">
                  <AccordionTrigger className="py-5 md:py-6 text-left hover:no-underline group">
                    <span className="flex items-center gap-5 md:gap-6 flex-1">
                      <span className="font-mono text-xs text-muted-foreground w-6">{String(i + 1).padStart(2, "0")}</span>
                      <span className={`font-bold text-lg md:text-xl leading-tight text-left ${isHi ? "font-hindi" : "font-sans"}`}>{f.q}</span>
                    </span>
                    <span className="w-8 h-8 grid place-items-center rounded-full bg-muted text-muted-foreground group-hover:bg-[#FFCC00] group-hover:text-black transition-colors shrink-0 ml-4 text-lg leading-none group-data-[state=open]:rotate-45 duration-500">
                      +
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 pl-12 md:pl-14 pr-4">
                    <p className={`text-base text-muted-foreground leading-relaxed max-w-2xl ${isHi ? "font-hindi" : ""}`}>{f.a}</p>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
